import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../MainPages.css';

export default function Financas() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em Proteção de Dados Pessoais (LGPD)</small></p>
            </Col>
            <Col xs="12">
                <h1>Proteção de Dados Pessoais (LGPD)</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <Link to="/dados-pessoais/lgpd-alepe" title="Listagem de Pessoal">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            LGPD na Alepe
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
        </Row>
    );
}
